import { hc } from "hono/client";
import type AppType from "../../../api/src/types";

export const client = hc<typeof AppType>(
  process.env.NODE_ENV === "development"
    ? "http://localhost:3000"
    : "https://api.gomiles.eu",
  {
    // Use a function for headers to get a fresh token for each request
    headers: () => {
      const token = localStorage.getItem("auth_token");
      const headers: Record<string, string> = {};

      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }

      return headers;
    },
  }
);
